export type CollaborationGraphContainerDetails = {
	iconUrl: string;
	id: string;
	key: string;
	name: string;
	url: string;
	product: string;
	subproduct: string | null;
};

// The collabgraph API currently only supports two container types
export type CollabContainerType = 'jiraProject' | 'confluenceSpace';

export type CollaborationGraphContainer = {
	containerDetails: CollaborationGraphContainerDetails;
	containerType: CollabContainerType;
	entityType: string;
	id: string;
	score: number;
	siteId: string;
};

export type CollaborationGraphContainerRequestBody = {
	containerTypes: string[];
	context: {
		contextType: string;
		principalId: string | undefined;
		siteIds: string[];
	};
	expanded: boolean;
	maxNumberOfResults: number;
	userId: string | undefined;
};

export type CollabGraphContainerResponse = {
	collaborationGraphEntities: CollaborationGraphContainer[];
};

export type CollaborationGraphObject = {
	expand: {
		ari: string;
		key?: string;
		title?: string;
		url: string;
	};
	id: string;
	score: number;
};

export const supportedCollabGraphObjectProducts = ['jira', 'confluence'] as const;
export type SupportedCollabGraphObjectProduct = (typeof supportedCollabGraphObjectProducts)[number];

export interface Context {
	product: SupportedCollabGraphObjectProduct;
	tenantId: string;
	userId: string;
}

export interface CollaborationGraphObjectRequestBody {
	contexts: Context[];
	expand: 'none' | 'existing' | 'all';
	maxNumberOfResults: number;
	modelRequestParams: {
		caller: string;
		experience: string;
	};
	requestingUserId: string;
	sessionId: string;
}

export interface CollaborationGraphObjectResponse {
	recommendedEntities: CollaborationGraphObject[];
}
